import { render, staticRenderFns } from "./DeleteFormModal.vue?vue&type=template&id=1b95fde9&"
import script from "./DeleteFormModal.vue?vue&type=script&lang=js&"
export * from "./DeleteFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports